var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"show-more"},[_c('div',{staticClass:"just-font cu-point fs16",class:_vm.$themeStyle(_vm.$store.state.theme.theme),on:{"click":function($event){return _vm.showMore()}}},[_vm._v(" 查看更多 "),_c('span',{staticClass:"iconfont el-icon-arrow-right"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }